import { render, staticRenderFns } from "./UserTodos.vue?vue&type=template&id=0c29c90c&"
import script from "./UserTodos.vue?vue&type=script&lang=js&"
export * from "./UserTodos.vue?vue&type=script&lang=js&"
import style0 from "./UserTodos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports